import React, { useState, useEffect } from "react";
import MUITable from "../../Common/MUITable";
import ExcelJS from "exceljs";
import CorporationForm from "./CorporationForm";
import ModalComponent from "../../Common/popup_modal/ModalComponent";
import { CorporationStore } from "./CorporationStore";
import { useDropdownStore } from "../AssetVehicle/store/useDropdownStore";
import { Loader } from "react-feather";
import isGHMC from "../../Common/helper/helpar";
import TableSkeleton from "../AllotedMaster/TableSkeleton";

const Corporation = () => {
  const [showModal, setShowModal] = useState(false);
    const isProd = isGHMC();
  const {
    fetchCorporationDetails,
    CorporationDetailsForMasters,
    isFetchCorporationDetailsLoading,
   
    setEditData,
    EditData,
  } = CorporationStore();
  const { resetFileInputs } = useDropdownStore();
  
  
  useEffect(() => {
    fetchCorporationDetails();
  }, []);

  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Corporation Details");
    const boldFont = { bold: true };
    const generationTime = new Date().toLocaleString("en-GB");
    const downloadDateTime = `Corporation Report Generated on: ${generationTime}`;

    worksheet.addRow([downloadDateTime]);
    worksheet.mergeCells(1, 1, 1, 3);
    worksheet.getCell(1, 1).font = boldFont;
    worksheet.getCell(1, 1).alignment = { horizontal: "center" };
    worksheet.addRow([""]);

    const headerRow = worksheet.addRow(["S.No", "Corporation Name", "Status"]);
    headerRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFDDDDDD" },
      };
    });

    (CorporationDetailsForMasters || []).forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.corporationName || "",
        item.isActive ? "Active" : "Inactive",
      ]);
    });

    worksheet.columns = [{ width: 6 }, { width: 30 }, { width: 15 }];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CorporationDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  /* ================= TABLE COLUMNS ================= */
  const CorporationColumns = [
    {
      label: "Corporation Name",
      field: "corporationName",
    },
    {
      label: "Status",
      field: "isActive",
        render: (row) => (
        <div>
          {row.isActive ? (
            <span className="badge bg-success">Active</span>
          ) : (
            <span className="badge bg-danger">Inactive</span>
          )}
        </div>
      ),
    },

    {
      label: "Action",
      field: "Action",
      render: (row) => (
        <div>
          <button
            className={`btn btn-sm ${isProd ? "btn-primary" : "btn-danger"} me-2`}
            onClick={() => {
              setEditData(row);
              setShowModal(true);
            }}
            title="Edit"
          >
            <i className="fa-solid fa-edit"></i>
          </button>
        </div>
      ),
    },
  ];

  
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group"></div>
                </div>
                <div className="col-md-6">
                  <div className=" flex_end_middle mb-3">
                    {/* {canAdd && ( */}
                    {true ? (
                      <button
                        className="button-container"
                        onClick={() => {
                          setEditData(null);
                          setShowModal(true);
                        }}
                      >
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        Add Corporation
                      </button>
                    ) : (
                      ""
                    )}
                    {/* )} */}
                    <button className="btn btn-excel" onClick={downloadAsExcel}>
                      <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                      Excel
                    </button>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    <span>Corporation Details</span>
                  </div>
                  {isFetchCorporationDetailsLoading ? (
                    <TableSkeleton />
                  ) : (
                    <MUITable
                      needSRNumber
                      //   hasTotalRow
                      tableHeight={500}
                      columns={CorporationColumns}
                      rows={CorporationDetailsForMasters}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Add/Edit Corporation */}
      <ModalComponent
        title={EditData ? "Edit Corporation" : "Add Corporation"}
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setEditData(null);
          resetFileInputs();
        }}
        handleClose={() => {
          setShowModal(false);
          setEditData(null);
          resetFileInputs();
        }}
      >
        <CorporationForm
          handleClose={() => {
            setShowModal(false);
            setEditData(null);
            resetFileInputs();
          }}
        />
      </ModalComponent>
    </>
  );
};

export default Corporation;
